/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateAppointmentResponse
 */
export interface CreateAppointmentResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateAppointmentResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the CreateAppointmentResponse interface.
 */
export function instanceOfCreateAppointmentResponse(value: object): value is CreateAppointmentResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateAppointmentResponseFromJSON(json: any): CreateAppointmentResponse {
    return CreateAppointmentResponseFromJSONTyped(json, false);
}

export function CreateAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
    };
}

export function CreateAppointmentResponseToJSON(json: any): CreateAppointmentResponse {
    return CreateAppointmentResponseToJSONTyped(json, false);
}

export function CreateAppointmentResponseToJSONTyped(value?: CreateAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
    };
}

